import { ca } from '@cian/analytics';
import { getProductsData } from '../../selectors/analytics';
import { IPromoIdExtraObject } from '../../types/analytics';
import { EMortgageOffersTabs } from '../../types/mortgageOffers';
import { IPromo } from '../../types/newbuilding/promos';

const ANALYTICS_TABS_MAP: Record<EMortgageOffersTabs, string> = {
  [EMortgageOffersTabs.Banks]: 'accredited_banks',
  [EMortgageOffersTabs.Mortgage]: 'mortgage_offers',
  [EMortgageOffersTabs.SeoUrl]: 'seo_url',
};

export function trackMortgageOffersTabClick(tab: EMortgageOffersTabs) {
  ca('eventSite', {
    action: 'click',
    category: 'Promo',
    label: ANALYTICS_TABS_MAP[tab],
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackPromoOffersShow(promos: IPromo[], newbuildingId: number, isMortgage = false) {
  const promoId: IPromoIdExtraObject[] = promos.map((promo, index) => ({
    promo_type: promo.promoType,
    promo_id: promo.promoId,
    position: index + 1,
  }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: isMortgage ? 'mortgage_offers' : 'promo_offers',
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId })],
  });
}
